import Vue from 'vue';

export default {
    bind: function (el, binding, vnode) {
        setTimeout(() => {
            const value = binding.arg || binding.value;
            const target = value ? document.getElementById(value) : document.body,
                    body = document.body.getBoundingClientRect(),
                    elem = target.getBoundingClientRect(),
                    top   = elem.top - body.top;
    
            el.addEventListener('click', (e) => {
                window.scrollTo(0, top)
            })
        }, 500)
    }
}